module.exports = __webpack_public_path__ + "static/media/markerAlert.6bde3fbf.svg";